// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkuCarsFitment_sku-cars-fitment__jIYdG {
  border: 1px solid var(--black-ten-opacity);
  border-radius: 1rem;
  padding: 3rem 2rem;
  max-height: 86rem;
  overflow-y: auto;
}

.SkuCarsFitment_sku-cars-fitment__header__GLKe\\+ {
  color: var(--primary-color);
  font-size: var(--text-xl);
  font-weight: 700;
  margin-bottom: 5rem;
}

.SkuCarsFitment_sku-cars-fitment__list__-t3Gs {
  display: flex;
  flex-direction: column;
  gap: 5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/SkuDetails/SkuCarsFitment/SkuCarsFitment.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".sku-cars-fitment {\n  border: 1px solid var(--black-ten-opacity);\n  border-radius: 1rem;\n  padding: 3rem 2rem;\n  max-height: 86rem;\n  overflow-y: auto;\n}\n\n.sku-cars-fitment__header {\n  color: var(--primary-color);\n  font-size: var(--text-xl);\n  font-weight: 700;\n  margin-bottom: 5rem;\n}\n\n.sku-cars-fitment__list {\n  display: flex;\n  flex-direction: column;\n  gap: 5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sku-cars-fitment": `SkuCarsFitment_sku-cars-fitment__jIYdG`,
	"sku-cars-fitment__header": `SkuCarsFitment_sku-cars-fitment__header__GLKe+`,
	"sku-cars-fitment__list": `SkuCarsFitment_sku-cars-fitment__list__-t3Gs`
};
export default ___CSS_LOADER_EXPORT___;
